import { render, staticRenderFns } from "./CoursePresentation.vue?vue&type=template&id=6b1fe7cc&scoped=true&"
import script from "./CoursePresentation.vue?vue&type=script&lang=js&"
export * from "./CoursePresentation.vue?vue&type=script&lang=js&"
import style0 from "./CoursePresentation.vue?vue&type=style&index=0&id=6b1fe7cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1fe7cc",
  null
  
)

component.options.__file = "CoursePresentation.vue"
export default component.exports